import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import au from "./translations/au.json";
import en from "./translations/en.json";
import es from "./translations/es.json";
import fr from "./translations/fr.json";
import gr from "./translations/gr.json";
import it from "./translations/it.json";
import no from "./translations/no.json";
import ro from "./translations/ro.json";
import us from "./translations/us.json";

import { CountryISOCode } from "./useHoldingInfo";

export const resources = {
  au: { translation: au },
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  gr: { translation: gr },
  it: { translation: it },
  no: { translation: no },
  ro: { translation: ro },
  us: { translation: us },
} as const;

export const defaultNS = "translation" satisfies keyof (typeof resources)[keyof typeof resources];

export type LanguageResources = keyof typeof resources;

export const mapCountryToLanguage = (countryCode: CountryISOCode): LanguageResources => {
  switch (countryCode) {
    case CountryISOCode.AU:
    case CountryISOCode.NZ:
      return "au";
    case CountryISOCode.GB:
    case CountryISOCode.IE:
      return "en";
    case CountryISOCode.US:
    case CountryISOCode.CA:
      return "us";
    case CountryISOCode.IL:
      return "en";
    case CountryISOCode.IT:
      return "it";
    case CountryISOCode.NO:
      return "no";
    case CountryISOCode.MX:
    case CountryISOCode.ES:
      return "es";
    case CountryISOCode.RO:
      return "ro";
    case CountryISOCode.FR:
      return "fr";
    case CountryISOCode.GR:
      return "gr";
    default:
      return "en"; // Default to English if no matching language found
  }
};

export interface LanguageCode {
  country: string;
  languageLabel: string;
  languageCode: string;
}

export const languageCodes: LanguageCode[] = [
  {
    country: "United Kingdom",
    languageLabel: "English (UK)",
    languageCode: "en",
  },
  {
    country: "United States",
    languageLabel: "English (US)",
    languageCode: "us",
  },
  {
    country: "Australia",
    languageLabel: "English (Australian)",
    languageCode: "au",
  },
  {
    country: "Spain",
    languageLabel: "Español",
    languageCode: "es",
  },
  {
    country: "France",
    languageLabel: "Français",
    languageCode: "fr",
  },
  {
    country: "Greece",
    languageLabel: "Ελληνικά",
    languageCode: "gr",
  },
  {
    country: "Italy",
    languageLabel: "Italiano",
    languageCode: "it",
  },
  {
    country: "Norsk",
    languageLabel: "Norwegian",
    languageCode: "no",
  },
  {
    country: "Romania",
    languageLabel: "Română",
    languageCode: "ro",
  },
];

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: "en",
    resources,
    fallbackLng: "en",
    debug: false, // Setting to true will show missing translations in the logs
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
